import MicroModal from 'micromodal';
import {
  hasClass,
  addClass,
  removeClass,
  disableScroll,
} from '../helpers/helpers';
import { isMobileOrTablet } from '../helpers/layout';

const modalPanel = (function() {
  const modals = Array.from(document.querySelectorAll('.micromodal-slide'));
  const panelButtons = Array.from(
    document.querySelectorAll('.js-panel-button')
  );
  const panelButtonClose = document.querySelector('.js-panel-close-button');

  function showModal(modal) {
    const activeModal = document.getElementById(modal.id);
    //document.documentElement.style.overflow = 'hidden';
    heroButtonPositionCalc(modal.id);
    //disable scroll for form modals
    // modal-gallery-project intentionally omitted: GalleryIndex.vue locks
    // scroll itself before calling MicroModal.show, and a second call here
    // re-reads window.scrollY (now 0) and snaps the page to the top.
    if (
      modal.id == 'modal-find-rep' ||
      modal.id == 'modal-contact-rep' ||
      modal.id == 'modal-libris-image'
    ) {
      disableScroll(true);
    }
    //close any open ones
    modals.forEach(modal => {
      if (modal.classList.contains('is-open') && modal !== activeModal) {
        document.querySelector(`#${modal.id}`).classList.remove('is-open');
        document
          .querySelector(`#${modal.id}`)
          .setAttribute('aria-hidden', 'true');
      }
    });
  }

  function closeModal(modal) {
    document.location.hash = '';
    heroButtonPositionCalc(modal.id, true);
    //document.documentElement.style.overflow = 'visible';
    if (
      (modal.id == 'modal-materials-properties' ||
        modal.id == 'modal-materials-specs' ||
        modal.id == 'modal-product-specs' ||
        modal.id == 'modal-interlayers-detail' ||
        modal.id == 'modal-graphic_patterns-detail') &&
      isMobileOrTablet()
    ) {
      //reset buttons
      resetPanelButtons();
      addClass(panelButtonClose, 'is-active');
    }
    //enable scroll for form modals
    // modal-gallery-project handled in GalleryIndex.vue; see showModal above.
    if (
      modal.id == 'modal-find-rep' ||
      modal.id == 'modal-contact-rep' ||
      modal.id == 'modal-libris-image'
    ) {
      disableScroll(false);
    }
  }

  function heroButtonPositionCalc(modalId, closing = false) {
    if (
      (modalId == 'modal-materials-properties' ||
        modalId == 'modal-materials-specs') &&
      !isMobileOrTablet()
    ) {
      const specsBtn = document.querySelector('.js-materials-specs-button');
      if (closing) {
        resetButtonPosition(specsBtn);
      } else {
        if (modalId == 'modal-materials-properties' && !isMobileOrTablet()) {
          specsBtn.style.opacity = 0;
          setTimeout(() => {
            const modalHeight = document.querySelectorAll(
              `#${modalId} [role='dialog']`
            )[0].offsetHeight;
            specsBtn.style.marginTop = `${modalHeight -
              specsBtn.offsetHeight}px`;
            specsBtn.style.opacity = 1;
          }, 1000); //Modal Animation length
        } else {
          resetButtonPosition(specsBtn);
        }
      }
    }
  }

  function resetButtonPosition(specsBtn) {
    setTimeout(() => {
      specsBtn.style.marginTop = '0';
    }, 300); //Modal Animation length
  }

  function resetPanelButtons() {
    panelButtons.forEach(panelButton => {
      removeClass(panelButton, 'is-active');
    });
  }

  function setActive() {
    //reset all
    resetPanelButtons();
    //set this to active
    addClass(this, 'is-active');
  }

  function closePanelModals(evt) {
    //check to see if a modal is open
    modals.forEach(modal => {
      if (hasClass(modal, 'is-open')) {
        const modalId = modal.getAttribute('id');
        if (
          modalId == 'modal-materials-properties' ||
          modalId == 'modal-materials-specs' ||
          modalId == 'modal-product-specs' ||
          modalId == 'modal-interlayers-detail' ||
          modalId == 'modal-graphic_patterns-detail'
        ) {
          removeClass(modal, 'is-open');
          document
            .querySelector(`#${modalId}`)
            .setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  function init() {
    // delegate the initialization of the micromodal to the vue instance.
    if (window.location.pathname === '/image-gallery-portfolio') {
      return;
    }
    MicroModal.init({
      onShow: modal => showModal(modal),
      onClose: modal => closeModal(modal),
      awaitCloseAnimation: true,
    });
    if (panelButtonClose) {
      panelButtonClose.addEventListener('click', closePanelModals);
    }
    panelButtons.forEach(panelButton => {
      panelButton.addEventListener('click', setActive);
    });
  }

  return {
    init,
  };
})();

export default modalPanel;
